import type { ComponentType } from 'react';
import { Code } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { codeServerWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  codeServerWeb,
  {
    OpenEditorButton: () =>
      import('./OpenEditorButton') as unknown as Promise<Record<string, ComponentType>>,
  },
  {
    icons: { Code },
  },
);
